import { formatUnits } from '@ethersproject/units'
import { Grid } from '@material-ui/core'

var formatterUS = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
})

export const getLGFBuyBacks = response => {
    var number = 0
    response.data.data.data.items.map(item => {
        if (item.value > 0) {
            number += 1
        }
    })
    return number
}

export const getLGFBuyBacksPrice = response => {
    var price = 0
    response.data.data.data.items.map(item => {
        if (item.value > 0) {
            price +=
                parseFloat(formatUnits(item.value, 18)) * item.gas_quote_rate
        }
    })
    return price
}

export const getLGFBuyBacksDataTable = response => {
    var datatable = []
    response.data.data.data.items.map(item => {
        const dateBuy = new Date(item.block_signed_at)
        if (item.value > 0) {
            datatable.push([
                dateBuy.getUTCFullYear() +
                    '-' +
                    (dateBuy.getUTCMonth() + 1) +
                    '-' +
                    dateBuy.getUTCDate(),
                parseFloat(formatUnits(item.value, 18)),
                formatterUS.format(
                    parseFloat(formatUnits(item.value, 18)) *
                        item.gas_quote_rate
                ),
                item.tx_hash,
            ])
            // price +=  * item.gas_quote_rate;
        }
    })
    return datatable
}
